import React from 'react';
import RouletteSpinner from '../Components/RouletteSpinner';
import { useUser } from '../context/userContext';
import Animate from "../Components/Animate";

const Spin = () => {
  const { balance } = useUser();

  const formatNumber = (num) => {
    if (num < 100000) {
      return new Intl.NumberFormat().format(num).replace(/,/g, " ");
    } else if (num < 1000000) {
      return new Intl.NumberFormat().format(num).replace(/,/g, " ");
    } else {
      return (num / 1000000).toFixed(3).replace(".", ".") + " M";
    }
  };

  return (
    <Animate>
      <div className="w-full flex flex-col items-center justify-center px-4">
        <div id="refer" className="w-full h-screen pt-5 scroller overflow-y-auto pb-[150px] space-y-3">
          <div className="w-full flex justify-center items-center pb-3">
            <div className="w-fit bg-cards px-4 py-2 text-[15px] font-semibold rounded-full flex items-center justify-center space-x-1">
              <img src="/trigo_logo.png" alt="logo" className="w-[14px]"/>
              <span className="text-secondary">Balance</span> 
              <span className="text-white"> {formatNumber(balance)} </span>
            </div>
          </div>

          <div className="w-full px-3">
            <RouletteSpinner />
          </div>
        </div>
      </div>
    </Animate>
  );
};

export default Spin; 